// Tracks outstanding requests without changing their results or retry behavior.
let pendingRequests = 0;
const listeners = new Set();

function notifyLoading() {
    listeners.forEach(listener => listener(pendingRequests));
}

function subscribePageLoading(listener) {
    listeners.add(listener);
    listener(pendingRequests);
    return () => listeners.delete(listener);
}

function trackPageRequest(request) {
    pendingRequests += 1;
    notifyLoading();

    return Promise.resolve(request).finally(() => {
        pendingRequests = Math.max(0, pendingRequests - 1);
        notifyLoading();
    });
}

export { subscribePageLoading, trackPageRequest };
